/**
 * Created by denis.gusarov on 7/13/2017.
 */
namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Tween = Factive.Core.Tween.Tween;

    export class DiceObject {
        public id:number;
        public object: any;
        private size: number;
        private invertUpside: boolean;
        private materialOptions: {specular: number; color: number; shininess: number; shading: THREE.Shading};
        private labelColor: string;
        private diceColor: string;
        //private customTextTextureFunction:(faceText: string, labelColor: string, diceColor: string)=>THREE.Texture;

        protected values: number;
        protected scaleFactor: number;
        protected vertices: Array<number[]>;
        protected faces: Array<number[]>;
        protected faceTexts: Array<string>;
        protected faceColors: Array<number>;
        protected chamfer: number;
        protected tab: number;
        protected af: number;
        protected textMargin: number;
        protected inertia: number;
        protected mass: number;
        private simulationRunning: boolean;
        private materials: Array<THREE.Material>;
        private colorIndex: number;
        private portraitBody: THREE.Mesh;
        public index: number;
        private _aspectRatio: string;
        public value: number = null;

        constructor(options, private diceManager: DiceManagerClass) {
            options = this.setDefaults(options, {
                size: 100,
                fontColor: '#000000',
                backColor: '#ffffff',
                id: 0,
                index: 0
            });

            this.object = null;
            this.size = options.size;
            this.id = options.id;
            this.index = options.index;
            this.invertUpside = false;

            this.materialOptions = {
                //specular: 0x172022,
                color: 0xf0f0f0,
                //hininess: 40,
                flatShading: true
                //shading: THREE.FlatShading//SmoothShading
            };
            this.labelColor = options.fontColor;
            this.diceColor = options.backColor;
        }

        setDefaults(options, defaults) {
            options = options || {};

            for(let key in defaults){
                if (!defaults.hasOwnProperty(key)) continue;

                if(!(key in options)){
                    options[key] = defaults[key];
                }
            }

            return options;
        }

        // emulateThrow(callback) {
        //     let stableCount = 0;

        //     let check = () => {
        //         if (this.isFinished()) {
        //             stableCount++;

        //             if (stableCount === 50) {
        //                 DiceManager.world.removeEventListener('postStep', check);
        //                 callback(this.getUpsideValue());
        //             }
        //         } else {
        //              stableCount = 0;
        //         }

        //         DiceManager.world.step(DiceManager.world.dt);
        //     };

        //     DiceManager.world.addEventListener('postStep', check);
        // }

        isFinished() {
            let threshold = 1;

            let angularVelocity = this.object.body.angularVelocity;
            let velocity = this.object.body.velocity;

            return (Math.abs(angularVelocity.x) < threshold && Math.abs(angularVelocity.y) < threshold && Math.abs(angularVelocity.z) < threshold &&
            Math.abs(velocity.x) < threshold && Math.abs(velocity.y) < threshold && Math.abs(velocity.z) < threshold);
        }

        getUpsideValue() {
            if(this.value == null){
                let face = this.getUpside();
                let materialIndex = face.materialIndex;
                let materials = this.object.material;
                for (let i = 0; i < materials.length; i++)
                {
                    if(materials[i].index == null || materials[i].index == undefined){
                        continue;
                    }
                    if(materials[i].index == materialIndex){
                        this.value = materials[i].value;
                        break;
                    }
                }
                //this.value = materialIndex - 1;
            }
            return this.value;
        }

        getColorIndex(): number{
            if(this.visible){
                let face = this.getUpside();
                this.colorIndex = this.getColorByMaterialIndex(face.materialIndex);
            }
            return this.colorIndex;
        }

        getUpside(): THREE.Face3 {
            let vector = new THREE.Vector3(0, 0, this.invertUpside ? -1 : 1);
            let closest_face;
            let closest_angle = Math.PI * 2;
            for (let i = 0; i < this.object.geometry.faces.length; ++i) {
                let face = this.object.geometry.faces[i];
                if (face.materialIndex === 0) continue;

                let angle = face.normal.clone().applyQuaternion(this.object.body.quaternion).angleTo(vector);
                if (angle < closest_angle) {
                    closest_angle = angle;
                    closest_face = face;
                }
            }
            return closest_face;
        }

        getCurrentVectors() {
            return {
                position: this.object.body.position.clone(),
                quaternion: this.object.body.quaternion.clone(),
                velocity: this.object.body.velocity.clone(),
                angularVelocity: this.object.body.angularVelocity.clone()
            };
        }

        setVectors(vectors) {
            this.object.body.position = vectors.position;
            this.object.body.quaternion = vectors.quaternion;
            this.object.body.velocity = vectors.velocity;
            this.object.body.angularVelocity = vectors.angularVelocity;
        }

        getUpsideMaterialIndex() {
            let vector = new THREE.Vector3(0, 0, this.invertUpside ? -1 : 1);
            let closest_face;
            let closest_angle = Math.PI * 2;
            for (let i = 0; i < this.object.geometry.faces.length; ++i) {
                let face = this.object.geometry.faces[i];
                if (face.materialIndex === 0) continue;

                let angle = face.normal.clone().applyQuaternion(this.object.body.quaternion).angleTo(vector);
                if (angle < closest_angle) {
                    closest_angle = angle;
                    closest_face = face;
                }
            }
            return closest_face.materialIndex - 1;
        }

        shiftUpperValue(toValue) {
            let geometry = this.object.geometry.clone();

            let fromValue = this.getUpsideMaterialIndex();

            for (let i = 0, l = geometry.faces.length; i < l; ++i) {
                let materialIndex = geometry.faces[i].materialIndex;
                if (materialIndex === 0) continue;

                materialIndex += toValue - fromValue - 1;
                while (materialIndex > this.values) materialIndex -= this.values;
                while (materialIndex < 1) materialIndex += this.values;

                geometry.faces[i].materialIndex = materialIndex + 1;
            }

            this.object.geometry = geometry;
        }

        getChamferGeometry(vectors, faces, chamfer) {
            let chamfer_vectors = [], chamfer_faces = [], corner_faces = new Array(vectors.length);
            for (let i = 0; i < vectors.length; ++i) corner_faces[i] = [];
            for (let i = 0; i < faces.length; ++i) {
                let ii = faces[i], fl = ii.length - 1;
                let center_point = new THREE.Vector3();
                let face = new Array(fl);
                for (let j = 0; j < fl; ++j) {
                    let vv = vectors[ii[j]].clone();
                    center_point.add(vv);
                    corner_faces[ii[j]].push(face[j] = chamfer_vectors.push(vv) - 1);
                }
                center_point.divideScalar(fl);
                for (let j = 0; j < fl; ++j) {
                    let vv = chamfer_vectors[face[j]];
                    vv.subVectors(vv, center_point).multiplyScalar(chamfer).addVectors(vv, center_point);
                }
                face.push(ii[fl]);
                chamfer_faces.push(face);
            }
            for (let i = 0; i < faces.length - 1; ++i) {
                for (let j = i + 1; j < faces.length; ++j) {
                    let pairs = [], lastm = -1;
                    for (let m = 0; m < faces[i].length - 1; ++m) {
                        let n = faces[j].indexOf(faces[i][m]);
                        if (n >= 0 && n < faces[j].length - 1) {
                            if (lastm >= 0 && m !== lastm + 1) pairs.unshift([i, m], [j, n]);
                            else pairs.push([i, m], [j, n]);
                            lastm = m;
                        }
                    }
                    if (pairs.length !== 4) continue;
                    chamfer_faces.push([chamfer_faces[pairs[0][0]][pairs[0][1]],
                        chamfer_faces[pairs[1][0]][pairs[1][1]],
                        chamfer_faces[pairs[3][0]][pairs[3][1]],
                        chamfer_faces[pairs[2][0]][pairs[2][1]], -1]);
                }
            }
            for (let i = 0; i < corner_faces.length; ++i) {
                let cf = corner_faces[i], face = [cf[0]], count = cf.length - 1;
                while (count) {
                    for (let m = faces.length; m < chamfer_faces.length; ++m) {
                        let index = chamfer_faces[m].indexOf(face[face.length - 1]);
                        if (index >= 0 && index < 4) {
                            if (--index === -1) index = 3;
                            let next_vertex = chamfer_faces[m][index];
                            if (cf.indexOf(next_vertex) >= 0) {
                                face.push(next_vertex);
                                break;
                            }
                        }
                    }
                    --count;
                }
                face.push(-1);
                chamfer_faces.push(face);
            }
            return { vectors: chamfer_vectors, faces: chamfer_faces };
        }

        makeGeometry(vertices, faces, radius, tab, af) : THREE.Geometry{
            let geom = new THREE.Geometry();
            for (let i = 0; i < vertices.length; ++i) {
                let vertex = vertices[i].multiplyScalar(radius);
                vertex.index = geom.vertices.push(vertex) - 1;
            }
            for (let i = 0; i < faces.length; ++i) {
                let ii = faces[i], fl = ii.length - 1;
                let aa = Math.PI * 2 / fl;
                for (let j = 0; j < fl - 2; ++j) {
                    geom.faces.push(new THREE.Face3(ii[0], ii[j + 1], ii[j + 2], [geom.vertices[ii[0]],
                        geom.vertices[ii[j + 1]], geom.vertices[ii[j + 2]]], 0, ii[fl] + 1));
                    geom.faceVertexUvs[0].push([
                        new THREE.Vector2((Math.cos(af) + 1 + tab) / 2 / (1 + tab),
                            (Math.sin(af) + 1 + tab) / 2 / (1 + tab)),
                        new THREE.Vector2((Math.cos(aa * (j + 1) + af) + 1 + tab) / 2 / (1 + tab),
                            (Math.sin(aa * (j + 1) + af) + 1 + tab) / 2 / (1 + tab)),
                        new THREE.Vector2((Math.cos(aa * (j + 2) + af) + 1 + tab) / 2 / (1 + tab),
                            (Math.sin(aa * (j + 2) + af) + 1 + tab) / 2 / (1 + tab))]);
                }
            }
            geom.computeFaceNormals();
            geom.boundingSphere = new THREE.Sphere(new THREE.Vector3(), radius);
            return geom;
        }

        createShape(vertices, faces, radius) : CANNON.Shape {
            let cv = new Array(vertices.length), cf = new Array(faces.length);
            for (let i = 0; i < vertices.length; ++i) {
                let v = vertices[i];
                cv[i] = new CANNON.Vec3(v.x * radius, v.y * radius, v.z * radius);
            }
            for (let i = 0; i < faces.length; ++i) {
                cf[i] = faces[i].slice(0, faces[i].length - 1);
            }
            return new CANNON.ConvexPolyhedron(cv, cf);
        }

        getGeometry() {
            let radius = this.size * this.scaleFactor;

            let vectors = new Array(this.vertices.length);
            for (let i = 0; i < this.vertices.length; ++i) {
                vectors[i] = (new THREE.Vector3).fromArray(this.vertices[i]).normalize();
            }

            let chamferGeometry = this.getChamferGeometry(vectors, this.faces, this.chamfer);
            let geometry = this.makeGeometry(chamferGeometry.vectors, chamferGeometry.faces, radius, this.tab, this.af);
            geometry.cannon_shape = this.createShape(vectors, this.faces, radius);

            return geometry;
        }

        private colorsIndexes = {};
        private material = null;

        shuffleArray(a) {
            for (let i = a.length; i; i--) {
                let j = Math.floor(Math.random() * i);
                [a[i - 1], a[j]] = [a[j], a[i - 1]];
            }
        }

        getMaterials() {
            this.colorsIndexes = {};
            let materials = [];
            this.shuffleArray(this.faceColors);
            for (let i = 0; i < this.faceTexts.length; ++i) {

                let texture = this.diceManager.getTexture(this.faceTexts[i], this.faceColors);

                if(texture == null){
                    if(this.material == null){
                        if(this.diceManager.usePhongMaterial){
                            this.material = new THREE.MeshPhongMaterial(Factive.Core.Underscore.extend(this.materialOptions, {map: this.diceManager.texture}));
                        } else {
                            this.material = new THREE.MeshLambertMaterial(Factive.Core.Underscore.extend(this.materialOptions, {map: this.diceManager.texture}));
                        }
                    }
                    materials.push(this.material);
                }
                else{
                    let material;
                    if(this.diceManager.usePhongMaterial){
                        material = new THREE.MeshPhongMaterial(Factive.Core.Underscore.extend(this.materialOptions, {map: texture}));
                    } else {
                        material = new THREE.MeshLambertMaterial(Factive.Core.Underscore.extend(this.materialOptions, {map: texture}));
                    }

                    materials.push(material);
                    if(texture.colorId != null && texture.colorId != undefined){
                        material.colorId = texture.colorId;
                        material.index = i;
                        material.value = parseInt(this.faceTexts[i], 10);
                    }
                }
            }

            return materials;
        }

        mixColors(){
            let materials = this.object.material;
            this.shuffleArray(this.faceColors);
            for (let i = 0; i < materials.length; i++)
            {
                if(materials[i].index == null || materials[i].index == undefined){
                    continue;
                }
                let texture =  this.diceManager.getTexture(this.faceTexts[materials[i].index], this.faceColors);
                if(texture != null){
                    if(texture.colorId){
                        materials[i].map = texture;
                        materials[i].colorId = texture.colorId;
                        materials[i].needsUpdate = true;
                    }
                }
            }
        }

        getObject() {
            return this.object;
        }

        getColorByMaterialIndex(materialIndex){
            let materials = this.object.material;
            for (let i = 0; i < materials.length; i++)
            {
                if(materials[i].index == null || materials[i].index == undefined){
                    continue;
                }
                if(materials[i].index == materialIndex){
                    return materials[i].colorId;
                }
            }
            return null;
        }

        create() {
            if (!this.diceManager.world) throw new Error('You must call DiceManager.setWorld(world) first.');

            this.materials = this.getMaterials();
            this.object = new THREE.Mesh(this.getGeometry(), this.materials);//new THREE.MultiMaterial()

            this.object.reveiceShadow = true;
            this.object.castShadow = true;
            this.object.diceObject = this;
            this.object.body = new CANNON.Body({
                mass: this.mass,
                shape: this.object.geometry.cannon_shape,
                material: this.diceManager.diceBodyMaterial
            });
            this.object.body.linearDamping = 0.1;
            this.object.body.angularDamping = 0.1;
            //this.diceManager.world.addBody(this.object.body);

            //this.portraitBody = this.object.clone();

            this.diceManager.world.addBody(this.object.body);

            return this.object;
        }

        public visible: boolean = false;

        hide(){
            this.visible = false;
            this.diceManager.scene.remove(this.object);


            //this.diceManager.world.remove(this.object.body);
            //this.diceManager.scene.remove(this.portraitBody);
        }

        show(){
            this.visible = true;
            this.diceManager.scene.add(this.object);

            if(this._aspectRatio == "landscape"){
                this.object.position.copy(this.object.body.position);
            } else if(this._aspectRatio == "portrait") {
                this.object.position.x = 5.5;
                this.object.position.y = this.index * 2.5 - 4.8;
                this.object.position.z = -4.1;
            }
            this.object.quaternion.copy(this.object.body.quaternion);

            if(this.value != null){
                this.shiftUpperValue(this.value);
            }

            //this.diceManager.world.addBody(this.object.body);
            //this.diceManager.scene.add(this.portraitBody);
        }

        updateMeshFromBody() {
            if (!this.simulationRunning && this.visible) {
                //if(this._aspectRatio == "landscape"){
                    this.object.position.copy(this.object.body.position);
                // } else if(this._aspectRatio == "portrait") {
                //     this.object.position.x = 5.5;
                //     this.object.position.y = this.index * 2.3 - 4.8;
                //     this.object.position.z = -4.1;
                // }
                this.object.quaternion.copy(this.object.body.quaternion);
            }
        }

        updateBodyFromMesh() {
            this.object.body.position.copy(this.object.position);
            this.object.body.quaternion.copy(this.object.quaternion);
        }

        getPosition() {
            if(this._aspectRatio == "landscape"){
                return this.object.position;
            } else if(this._aspectRatio == "portrait") {
                let destinationPoint = new THREE.Vector3();
                destinationPoint.x = 5.5;
                destinationPoint.y = this.index * 2.5 - 4.8;
                destinationPoint.z = -4.1;
                return destinationPoint;
            }
        }

        applyAspectRatio(aspectRatio: string) {
            this._aspectRatio = aspectRatio;
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Dices/DiceObject.ts